// 极薄 fetch 封装。响应形状对齐 @aliashub/shared/api：{ success, data } / { success, error }
// 失败时抛出 ApiError；前端 try/catch 或 TanStack Query 的 onError 捕获

import type { ApiResponse } from '@aliashub/shared/api';

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly details?: unknown,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function apiFetch<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const res = await fetch(path, {
    ...init,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...(init.body ? { 'Content-Type': 'application/json' } : {}),
      ...init.headers,
    },
  });

  if (res.status === 204) return undefined as T;

  const body = (await res.json().catch(() => null)) as ApiResponse<T> | null;
  if (!body) {
    throw new ApiError(res.status, 'INTERNAL_ERROR', '响应格式错误');
  }
  if (!body.success) {
    throw new ApiError(res.status, body.error.code, body.error.message, body.error.details);
  }
  return body.data;
}

export const api = {
  get: <T>(path: string) => apiFetch<T>(path),
  post: <T>(path: string, body?: unknown) =>
    apiFetch<T>(path, body != null ? { method: 'POST', body: JSON.stringify(body) } : { method: 'POST' }),
  patch: <T>(path: string, body?: unknown) =>
    apiFetch<T>(
      path,
      body != null ? { method: 'PATCH', body: JSON.stringify(body) } : { method: 'PATCH' },
    ),
  delete: <T>(path: string) => apiFetch<T>(path, { method: 'DELETE' }),
};
